module.exports = __webpack_public_path__ + "static/media/location-king-001760.92e1d85c.svg";